import styled from 'styled-components';

import Button from 'components/button/Button';

export const LeadCellButtonStyled = styled(Button)`
  padding-bottom: 0;
  padding-top: 0;
`;
